import { isLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { getPrices } from '../utils/get-prices.js';
import { createImageUrl } from '../utils/create-image-url.js';
import { getProductTitle } from '../utils/get-product-title.js';
import { getProductSubtitle } from '../utils/get-product-subtitle.js';
import { getProductA11yLabel } from '../utils/get-product-a11y-label.js';
import { createLineItemId } from '../utils/create-line-item-id.js';

const toBaseLineItem = (orderLineItem, intl, options = {})=>{
    const { lineItemOriginalPrice , lineItemDiscountedPrice  } = getPrices(orderLineItem);
    return {
        lineItemId: createLineItemId(orderLineItem),
        productQuantity: `${intl.getLabel('cart.item.quantity')}: ${orderLineItem.quantity}`,
        productSku: orderLineItem.product.sku,
        productImage: createImageUrl(orderLineItem.product.mainImage, options),
        title: getProductTitle(orderLineItem, intl),
        subtitle: getProductSubtitle(orderLineItem, intl),
        productA11yLabel: getProductA11yLabel(orderLineItem, intl),
        isReorderAvailable: isLineItemReorderable(orderLineItem),
        lineItemOriginalPrice,
        lineItemDiscountedPrice
    };
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
